import React, { Fragment } from 'react';
import cn from 'classnames';
import { price } from '../../utils/format';
import SvgIcon from '../../../../common/SvgIcon';

const GettingStartedPackageRoom = ({
  value,
  room,
  prices,
  removable = false,
  onChange,
  onRemove,
}) => {
  const selected = value[room.value] && value[room.value].plan;
  const onChangePlan = function(newPlanId) {
    const p = prices[room.name] && prices[room.name].plans.find(p => p.id === newPlanId);
    p && onChange(room, p);
  };
  return (
    <div className={cn('getting-started_tag -stack', { '-active': Boolean(selected) })}>
      {removable && <span className="getting-started_tag-close" onClick={() => onRemove(room)} />}

      <svg className="getting-started_tag-image">
        <use xlinkHref={`${window.roomIconsSprite || ''}#icon_room-${room.icon}`} xmlnsXlink="http://www.w3.org/1999/xlink" />
      </svg>

      <div className="getting-started_tag-label">{room.label}</div>

      <div className="getting-started_tag-plan">
        <div className="getting-started_tag-plan_name">Select package</div>

        <div className="getting-started_tag-plan_options">
          {prices[room.name] &&
            prices[room.name].plans.map(plan => (
              <label className="checkbox" key={`${plan.id}`}>
                <input
                  className="checkbox_input"
                  type="radio"
                  name={`${room.value}-plan`}
                  id={`${room.value}-${plan.id}`}
                  value={plan.id}
                  defaultChecked={value[room.value] && value[room.value].plan === plan.id}
                  onChange={e => {
                    onChangePlan(e.target.value);
                  }}
                />
                <SvgIcon icon="icon-check" className="checkbox_icon" />
                <span className="checkbox_label">{`${plan.name} ${price(plan.price)}`}</span>
              </label>
            ))}
        </div>
        {/*<select*/}
        {/*value={selected}*/}
        {/*className="getting-started_tag-plan_selector"*/}
        {/*onChange={e => {*/}
        {/*const p =*/}
        {/*prices[room.name] && prices[room.name].plans.find(p => p.id === e.target.value);*/}
        {/*p && onChange(room, p);*/}
        {/*}}*/}
        {/*>*/}
        {/*<option value={undefined} disabled selected>*/}
        {/*Select room package*/}
        {/*</option>*/}
        {/*{prices[room.name] &&*/}
        {/*prices[room.name].plans.map(plan => (*/}
        {/*<option key={`plan-${plan.id}`} value={plan.id}>*/}
        {/*{plan.name} {price(plan.price)}*/}
        {/*</option>*/}
        {/*))}*/}
        {/*</select>*/}
      </div>
    </div>
  );
};

export default GettingStartedPackageRoom;



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/components/GettingStartedPackage/GettingStartedPackageRoom.js